/**
 * This Component is triggered when user click on view all link in auto suggest panel or presses enter
 */

import globals from '../../../common/globals';
import vxListPage from '../vx-list-page/vx-list-page.vue';
import vxDropdownPrimary from '../../../common/vx-dropdown-primary/vx-dropdown-primary.vue';
import cookiesMixin from '../../../common/mixins/cookies-mixin';
import vxSpinner from '../../../common/vx-spinner/vx-spinner.vue';
import AnalyticsService from '../../../common/services/analytics-service';
import SearchBrowseService from '../../../common/services/search-browse-service';
import mobileMixin from '../../../common/mixins/mobile-mixin';
import flyoutBannerMixin from '../../../common/vx-flyout-banner/vx-flyout-banner-mixin';
import vxStarRating from '../../../common/vx-star-rating/vx-star-rating.vue';
import {
  facetName,
  contentType,
  brandValues,
  cookies,
  addToCartStatus,
  flyoutStatus,
} from '../../../common/mixins/vx-enums';

export default {
  name: 'vx-search-result',
  mixins: [cookiesMixin, mobileMixin, flyoutBannerMixin],
  props: {
    // indicates whether the site is configured for favorites
    isFavorites: {
      type: Boolean,
      default: false,
    },
    // indicates whether the site is configured for Bazaar Voice
    isBazaarVoice: {
      type: String,
      default: '',
    },
    // Copy text coming from properties files for search browse components
    searchBrowseI18n: {
      type: Object,
    },
    // indicates whether the site is configured for bulk
    isBulkEnabled: {
      type: Boolean,
      default: false,
    },
    // category id
    categoryId: {
      type: String,
      default: '',
    },
    // indicates whether it is search results page
    searchResultPage: {
      type: Boolean,
      default: false,
    },
    // indicates whether the site is configured for content
    isContentEnabled: {
      type: Boolean,
      default: false,
    },
    // indicates whether the site is configured for single product
    singleProductEnabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    vxListPage,
    vxDropdownPrimary,
    vxSpinner,
    vxStarRating,
  },
  data() {
    return {
      globals,
      cookies,
      addToCartStatus,
      flyoutStatus,
      contentType,
      brandValues,
      i18n: this.searchBrowseI18n.searchResult,
      searchData: {},
      appliedFilterList: [],
      sortsArray: [],
      contentSortArray: [],
      contentSortValue: '',
      contentSortType: '',
      searchString: '',
      currentSortValue: '',
      loadMoreProducts: false,
      pageNumber: 0,
      sortType: '',
      hideSortBy: false,
      filterHidden: true,
      bottom: false,
      productList: [],
      lazyLoadRequest: false,
      noResults: false,
      analyticsService: new AnalyticsService(),
      searchBrowseService: new SearchBrowseService(),
      dataLoaded: false,
      searchedTerm: '',
      showRating: false,
      showReviews: false,
      facetName,
      contentSearch: {},
      showContentTab: false,
      shareResource: {},
      showBackToTop: false,
      contentSearchData: [],
      selectedBulkProducts: [],
      selectAll: false,
      showPanel: false,
      bulkLazyLoad: false,
      maxCompareCount: '',
      guestListName: '',
      maxCompare: {
        mobile: 2,
        desktop: 4,
      },
      isCompareDisabled: false,
      compareCount: 0,
      isSampleOrderDisabled: true,
      showSampleOrderButton: false,
      defaultContentTab: false,
      selectedListName: '',
    };
  },
  watch: {
    bottom(bottom) {
      if (bottom) {
        this.loadMore();
      }
      this.toggleSelectAll();
    },
    selectedBulkProducts() {
      if (this.selectedBulkProducts.length > 0) {
        this.showPanel = true;
      } else {
        this.showPanel = false;
      }
      this.toggleSelectAll();
    },
  },
  computed: {
    isCategoryPage() {
      return !(
        this.searchData.freeTextSearch &&
         !(this.categoryId && this.categoryId.length > 0)
      );
    },
  },
  async mounted() {
    this.onInitCheck();

    window.addEventListener('scroll', (e) => {
      if (window.scrollY > 0 || window.pageYOffset > 0) {
        this.showBackToTop = true;
      } else {
        this.showBackToTop = false;
      }
      self.bottom = self.bottomVisible();
    });
  },
  methods: {
    /**
      * Function which indicates if the scroll has reached the bottom of the page
      */
    bottomVisible() {
      const scrollY = window.scrollY || window.pageYOffset;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const bottomOfPage = visible + scrollY >= pageHeight;
      return bottomOfPage || pageHeight < visible;
    },
    /**
      * Function for lazy loading
      */
    loadMore(event) {
      if (
        (this.searchData &&
           this.searchData.pagination.totalPages > this.pageNumber &&
           this.searchData.pagination.totalPages !== this.pageNumber + 1 &&
           !(
             (this.contentSearchData && this.contentSearchData.length) ||
             !this.isCategoryPage
           )) ||
         (this.searchData &&
           this.searchData.pagination.totalPages > this.pageNumber &&
           this.searchData.pagination.totalPages !== this.pageNumber + 1 &&
           !(
             (this.contentSearchData && this.contentSearchData.length) ||
             this.showContentTab
           )) ||
         (this.searchData &&
           this.searchData.pagination.totalPages > this.pageNumber &&
           this.searchData &&
           this.searchData.pagination.totalPages !== this.pageNumber + 1 &&
           document.querySelector(
             '.tab-container ul li.tab-item.active #tab-products',
           )) ||
         (this.contentSearch &&
           this.contentSearch.pagination &&
           this.contentSearch.pagination.totalPages > this.pageNumber &&
           this.contentSearch.pagination.totalPages !== this.pageNumber + 1 &&
           document.querySelector(
             '.tab-container ul li.tab-item.active #tab-content',
           ))
      ) {
        this.lazyLoadRequest = true;
        if (this.isBulkEnabled) {
          this.bulkLazyLoad = this.lazyLoadRequest;
        }
        this.pageNumber += 1;
        if (this.categoryId && this.categoryId.length > 0) {
          this.requestUrl = `/category/${this.categoryId}${window.location.search}&currentPage=${this.pageNumber}`;
        } else {
          this.requestUrl = `/search${window.location.search}&currentPage=${this.pageNumber}`;
        }
        this.generateUrlRequest(this.requestUrl);
      }
    },
    /**
      * Function is called on mounted which gets the categories and search results
      */
    onInitCheck() {
      if (this.categoryId && this.categoryId.length > 0) {
        // sending data to agileOne for tracking category browsed.
        // this.requestUrl = '/category/' + this.categoryId + window.location.search.replace('?q', '?query');
        this.requestUrl = `/category/${this.categoryId}${window.location.search}`;
        // Storing the value for category dropdown in B2B
        this.createCookie('categoryVal', this.categoryId);
      } else {
        this.requestUrl = `/search${window.location.search}`;
      }
      this.generateUrlRequest(this.requestUrl);
    },
    /**
      * Function to generate request URL
      * @param  {String} query string of search term
      */
    generateUrlRequest(query) {
      // query = updateQuery(query, response.data.freeTextSearch);
      let updatedQuery = query;
      if (this.searchedTerm !== '' && query.indexOf('searchText') < 0) {
        updatedQuery = `${query}${this.searchedTerm}`;
      }
      const self = this;
      if (this.globals.loggedIn) {
        const userId = this.globals.uid;
        self.searchBrowseService.getSearchResults(
          {},
          this.handleSearchResponse,
          this.handleSearchError,
          updatedQuery,
          userId,
        );
      } else {
        self.searchBrowseService.getSearchResults(
          {},
          this.handleSearchResponse,
          this.handleSearchError,
          updatedQuery,
        );
      }
      self.$refs.spinner.showSpinner();
    },
    /**
      * Function handles response of search service call
      */
    handleSearchResponse(response) {
      if (response.data.productResult) {
        if (this.isBulkEnabled && !this.lazyLoadRequest) {
          this.selectedBulkProducts = [];
        }
        this.searchData = response.data.productResult;
        if (response.data.contentResult) {
          this.contentSearch = response.data.contentResult;
          if (this.contentSearch.content && !this.searchData.products.length) {
            this.defaultContentTab = true;
          }
        }
      } else {
        this.searchData = response.data;
      }
      this.searchData.products.map((item) => {
        this.$set(item, 'isBulk', false);
      });

      // enabling content search tab on basis of following conditions
      if (
        (this.isContentEnabled &&
           !this.isCategoryPage &&
           this.contentSearch.content.length > 0) ||
         this.globals.isVanityfair()
      ) {
        this.showContentTab = true;
      }
      this.$refs.spinner.hideSpinner();
      const self = this;
      this.updateURL(
        this.searchData.currentQuery.url,
        this.searchData.freeTextSearch,
      );
      this.hideSortBy = true;
      if (
        this.searchData.products.length > 0 ||
         (this.isContentEnabled &&
           !this.isCategoryPage &&
           this.contentSearch &&
           this.contentSearch.content &&
           this.contentSearch.content.length > 0)
      ) {
        self.noResults = false;
      } else {
        self.noResults = true;
      }
      if (this.lazyLoadRequest) {
        this.searchData.products.map((item) => {
          self.productList.push(item);
        });
        if (this.contentSearch && this.contentSearch.content) {
          this.contentSearch.content.forEach((item) => {
            self.contentSearchData.push(item);
          });
        }
        self.lazyLoadRequest = false;
        self.noResults = false;
      } else {
        this.productList = this.searchData.products;
        if (this.contentSearch && this.contentSearch.content) {
          this.contentSearchData = this.contentSearch.content;
        }
      }
      if (this.requestUrl.indexOf('/search') === 0) {
        // sending the data to Google Analytics on enter in the search field
        this.analyticsService.trackSearchResults(this.searchData, () => {
          // sending data to agilOne
          this.trackSearchResults(this.searchData, () => {
            // generate categories banner data

            if (this.searchData.topImage) {
              this.globals.isCategoryImageAvailable = true;
            } else {
              this.globals.isCategoryImageAvailable = false;
            }

            this.globals.catergoryBannerData.componetType = 'imageWrapper';
            this.globals.catergoryBannerData.componentTheme = 'hero-center';
            this.globals.catergoryBannerData.backgroundImageD = this.searchData.topImage;
            this.globals.catergoryBannerData.headingText = this.searchData.categoryName;
          });
        });
      } else {
        if (this.searchData.topImage) {
          this.globals.isCategoryImageAvailable = true;
        } else {
          this.globals.isCategoryImageAvailable = false;
        }

        this.globals.catergoryBannerData.componetType = 'imageWrapper';
        this.globals.catergoryBannerData.componentTheme = 'hero-center';
        this.globals.catergoryBannerData.backgroundImageD = this.searchData.topImage;
        this.globals.catergoryBannerData.headingText = this.searchData.categoryName;
      }
    },
    /**
      * Function to update current URL as per searched term
      * @param  {String} url string of search url
      * @param  {String} term string of search term
      */
    updateURL(url, term) {
      if (url.indexOf('/search') >= 0) {
        url = url.replace('/search', '');
      } else if (this.categoryId) {
        url = `?${url.split('?')[1]}`;
      }
      if (this.searchedTerm === '') {
        this.searchedTerm = `&searchText=${term}`;
      }
      const path = window.location.pathname + url + this.searchedTerm;
      history.replaceState({}, 'Product Search', path);
    },
    /**
      * Function handles error of search service call
      */
    handleSearchError(error) {
      this.$refs.spinner.hideSpinner();
    },
    /**
      * Function will return searched category and filter name
      * @param  {String} categoryName string of category name
      * @param  {String} filterOptValue string of filter option value
      */

    /**
      * Function to reset current page number
      */
    resetCurrentPageNumber() {
      this.pageNumber = 0;
    },
    /**
      * Function will be used to create and encode search param url
      * @param  {Array} list array of list of filter values
      */
    createSearchQueryString(list) {
      this.searchString = '';
      list.map((item, index) => {
        this.searchString += `${item.category}:${item.filterValue}:`;
      });
      this.searchString = encodeURIComponent(this.searchString);
    },
    /**
      * Function to get the page back to top
      */
    onBackToTop() {
      window.scrollTo(0, 0);
    },
    /**
      * Function to generate query string
      * @param  {Array} prodArr array of product ids
      */
    generateProductsString(prodArr) {
      return prodArr.join(':');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/b2c/search-browse/vx-search-result/vx-search-result.js